import Config from '../config';
import {default as _} from '../helpers/Translate';

class Validation {

    static validate(input, errors, hints, validators) {
        let errorCounter = 0;
        for (let item in input) {
            for (let validator of validators[item]) {
                switch (validator) {
                    case 'required':
                        if (input[item].length <= 0) {
                            if (errors[item].length <= 0) {
                                errors[item] = _.init('lbl_validator__please') + ' ' +  _.init(`${item}`) + ' ' + _.init('lbl_validator__required');
                                hints[item]=_.init('this_field_required_hint')
                                errorCounter++;
                            }
                        }
                        break;
                    case 'required-file':
                        if (!input[item]) {
                            if (errors[item].length <= 0) {
                                errors[item] = _.init('lbl_validator__please') + ' ' +  _.init(`${item}`) + ' ' + _.init('lbl_validator__required');
                                errorCounter++;
                            }
                        }
                        break;
                    case 'email':
                        input[item] = input[item].trim()
                        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (!re.test(input[item])) {
                            if (errors[item].length <= 0) {
                                errors[item] = _.init(`${item}`) + ' ' + _.init('lbl_validator__Is_Not_Correct');
                                errorCounter++;
                            }
                        }
                        break;
                    case 'number':
                        if (!Number(input[item])) {
                            if (errors[item].length <= 0) {
                                errors[item] = _.init(`${item}`) + _.init('lbl_validator__Should_Be_Number');
                                errorCounter++;
                            }
                        }
                        break;
                    case 'mobile':
                        break;
                }
            }
        }
        return {
            'hints': hints, 'errors': errors, 'errorCount': errorCounter
        };
    }
}


export default Validation;